<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import { HeaderMobileWzW, HeaderDesktopWzW } from '.';

const mobile = ref(null);
const windowWidth = ref(null);
const showNavbar = ref(false);
const lastScrollPosition = ref(0);

function checkScreen() {
  windowWidth.value = window.innerWidth;
  if (windowWidth.value < 1000) {
    mobile.value = true;
    return;
  }
  mobile.value = false;
}

function onScroll() {
  const currentScrollPosition =
    window.screenY || document.documentElement.scrollTop;

  if (currentScrollPosition < 0) {
    return;
  }
  if (currentScrollPosition < 200) {
    showNavbar.value = true;
    return;
  }

  showNavbar.value = currentScrollPosition < lastScrollPosition.value;
  lastScrollPosition.value = currentScrollPosition;
}

onMounted(() => {
  window.addEventListener('resize', checkScreen);
  window.addEventListener('scroll', onScroll);
  checkScreen();
  onScroll();
});

onUnmounted(() => {
  window.removeEventListener('scroll', onScroll);
});
</script>

<template>
  <header class="header-background" :class="{ 'navbar-hidden': !showNavbar }">
    <nav>
      <HeaderMobileWzW v-show="mobile" />
      <HeaderDesktopWzW v-show="!mobile" />
    </nav>
  </header>
  <div class="header-margin"></div>
</template>

<style lang="scss" scoped>
$mobile-width: 1000px;
$main-header-height: 106px;
$main-header-mobile-onebar-height: 127px;
$main-header-mobile-height: 164px;
$bar-width: 500px;

.header-background {
  position: fixed;
  top: 0;
  z-index: 100;
  background-color: #fffbf8;
  display: flex;
  justify-content: center;
  width: 100vw;
  box-shadow: 0 2px 15px rgb(0 0 0 / 10%);
  transform: translate3d(0, 0, 0);
  transition: 0.3s all ease-out;
}

nav {
  width: 85%;
}

.header-margin {
  position: relative;
  width: 100%;
  margin-bottom: $main-header-height;

  @media (max-width: $mobile-width) {
    margin-bottom: $main-header-mobile-onebar-height;
  }

  @media (max-width: $bar-width) {
    margin-bottom: $main-header-mobile-height;
  }
}

.navbar-hidden {
  box-shadow: none;
  transform: translate3d(0, -100%, 0);
}
</style>
